export default "__VITE_ASSET__e421a13b__"